import { Theme } from '@mui/material';
import { borderRadius } from '@mui/system';

export const signInFormStyles = (theme: Theme, submitButtonColor?: string) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		backgroundColor: '#00000033',
		borderRadius: '8px',
		overflow: 'hidden',
		position: 'relative',
	},
	backButton: {
		position: 'absolute',
		top: '16px',
		left: '16px',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF66',
		width: '48px',
		height: '48px',

		'&.Mui-disabled': {
			color: 'rgba(255, 255, 255, 0.6)'
		},
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		width: '100%',
		p: { xs: '16px', sm: '24px' },
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		height: '48px',
		mb: '8px',
	},
	title: {
		textAlign: 'center',
		fontFamily: 'Integral CF',
		fontSize: '17px',
		fontWeight: 500,
		lineHeight: '20px',
		color: '#FFFFFF',
	},
	description: {
		fontFamily: 'Montserrat',
		fontSize: '17px',
		fontWeight: 400,
		lineHeight: '21px',
		color: '#FFFFFF',
	},
	separatorRow: {
		mb: '8px',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '11px',
	},
	separatorLine: {
		flexGrow: 1,
		height: '1px',
		borderBottom: '2px solid',
		borderColor: '#FFFFFF1A',
	},
	separatorText: {
		fontFamily: 'Montserrat',
		fontWeight: 500,
		fontSize: '16px',
		lineHeight: '20px',
		color: '#FFFFFF',
	},
	smallTextField: {
		width: '100px',
		flexGrow: 'unset',

		'& .MuiOutlinedInput-root': {
			borderRadius: '250px',

			'& .MuiOutlinedInput-notchedOutline': {
				borderRadius: '250px',
			},
		},

		'& .MuiInputBase-input': {
			textAlign: 'center',
			py: '12px',
			px: '24px',
		},
	},
	textField: {
		'& .MuiOutlinedInput-root': {
			borderRadius: '250px',

			'& .MuiOutlinedInput-input': {
				py: '12px',
			},

			'& .MuiOutlinedInput-notchedOutline': {
				borderRadius: '250px',
			},
		},
	},
	loginTypeButton: {
		width: '100%',
		maxWidth: '100%',
		borderRadius: '100px',
		p: '10px 38px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '10px',
		backgroundColor: '#00000080;',
		border: '1px solid #120E0D',
		boxShadow: '0px 2px 3px 0px #303030 inset',
		color: '#FFFFFF',

		'&.Mui-disabled': {
			color: 'rgba(255, 255, 255, 0.6)'
		},

		'&:hover': {
			backgroundColor: '#FFFFFF',
			color: '#000000',
		},
	},
	loginTypeButtonText: {
		fontSize: '16px',
		lineHeight: '20px',
		fontWeight: 600,
		fontFamily: 'Montserrat',
		textTransform: 'none',
	},
	submitButton: {
		width: '132px',
		height: '50px',
		p: '10px 32px',
		borderRadius: '52px',
		border: '1px solid #FFFFFF',

		color: 'black',
		backgroundColor: submitButtonColor || '#FFFFFF',

		textTransform: 'uppercase',
		fontFamily: 'Integral CF',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: '14px',

		'&:hover': {
			backgroundColor: submitButtonColor || '#FFFFFF',
			color: 'black',
		},

		'&:disabled': {
			backgroundColor: submitButtonColor || '#FFFFFF88',
			color: 'black',
		},
	},
	footer: {
		backgroundColor: '#00000033',
		background: '#00000033',
		py: '16px',
		display: 'flex',
		justifyContent: 'center',
	}
});
